var map = {
	"./golfsurfen--dark.svg": "96b7",
	"./kitesurfen--dark.svg": "b85f",
	"./multihull--dark.svg": "2a1e",
	"./suppen--dark.svg": "0c9c",
	"./windsurfen--dark.svg": "06c9",
	"./zeiljachten--dark.svg": "ad93",
	"./zeilwagenrijden--dark.svg": "565d",
	"./zwaardboten--dark.svg": "2b42"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9912";